export function normalizeJurisdictionState(
  state: string | null | undefined,
): string | null {
  if (state === null || state === undefined) return null
  const trimmed = state.trim()
  if (trimmed === '') return null
  const lowered = trimmed.toLowerCase()
  if (lowered === 'il' || lowered === 'illinois') return 'IL'
  if (lowered === 'sk' || lowered === 'saskatchewan') return 'SK'
  return trimmed.toUpperCase()
}

export type CatalogLicenseType = {
  key: string
  label: string
  description: string
}

export type CatalogJurisdiction = {
  state: string
  infoUrl?: string
  infoLabel?: string
  licenseTypes: CatalogLicenseType[]
}

export type JurisdictionLevel = 'state' | 'provincial' | 'federal_us' | 'federal_ca'

export type FederalSentinel = 'US' | 'CA'

export type CatalogLicenseTypeRule = {
  key: string
  jurisdictionLevel: JurisdictionLevel
  federalSentinel: FederalSentinel | null
}

export type LicenseCatalog = {
  jurisdictions: CatalogJurisdiction[]
  licenseTypes: CatalogLicenseTypeRule[]
}
